import { Tab, Tabs, TabsList } from "@merge-api/merge-javascript-shared";
import { useState } from "react";
import StagedComponentRulesContent from "./StagedComponentRulesContent";
import CommonModelDiffRunTab from "./CommonModelDiffRuns/CommonModelDiffRunTab";
import { useStagedComponentContext } from "../context/StagedComponentContext";

enum StagedComponentTabValue {
  ALERTS = "ALERTS",
  COMMON_MODEL_DIFFS = "COMMON_MODEL_DIFFS",
}

interface TabContentState {
  commonModelDiffsLoaded: boolean;
}

const StagedComponentTabs = () => {
  // context
  const { isFetchBlueprint } = useStagedComponentContext();

  // state
  const [activeTab, setActiveTab] = useState<StagedComponentTabValue>(
    StagedComponentTabValue.ALERTS
  );
  const [tabContentState, setTabContentState] = useState<TabContentState>({
    commonModelDiffsLoaded: false,
  });

  // function to handle tab change
  const handleTabChange = (_: any, newValue: string | number | null) => {
    if (typeof newValue === "string") {
      const newTabValue = newValue as StagedComponentTabValue;
      setActiveTab(newTabValue);

      // Mark the tab as loaded when first visited
      if (
        newTabValue === StagedComponentTabValue.COMMON_MODEL_DIFFS &&
        !tabContentState.commonModelDiffsLoaded
      ) {
        setTabContentState({
          ...tabContentState,
          commonModelDiffsLoaded: true,
        });
      }
    }
  };

  const renderAlertContent = () => <StagedComponentRulesContent />;

  // once flag is removed we will just remove the check for enabled
  if (!isFetchBlueprint) {
    return renderAlertContent();
  }

  return (
    <div className="w-full">
      <Tabs value={activeTab} variant="underline" onChange={handleTabChange}>
        <TabsList>
          <Tab value={StagedComponentTabValue.ALERTS}>Alerts</Tab>
          <Tab value={StagedComponentTabValue.COMMON_MODEL_DIFFS}>Common Model diffs</Tab>
        </TabsList>
      </Tabs>
      {activeTab === StagedComponentTabValue.ALERTS && renderAlertContent()}

      {/* Keep CommonModelDiffRunTab mounted once loaded, but only render when active */}
      {tabContentState.commonModelDiffsLoaded && (
        <div
          style={{
            display: activeTab === StagedComponentTabValue.COMMON_MODEL_DIFFS ? "block" : "none",
          }}
        >
          <CommonModelDiffRunTab />
        </div>
      )}

      {/* Only render on first activation if not yet loaded */}
      {activeTab === StagedComponentTabValue.COMMON_MODEL_DIFFS &&
        !tabContentState.commonModelDiffsLoaded && <CommonModelDiffRunTab />}
    </div>
  );
};

export default StagedComponentTabs;
